import React from 'react';
import { useTranslation } from 'react-i18next';
import Link from "../../../Link";
import Logo from "../../../../assets/app-only/images/logo.png";

interface BrandProps {
  sidebarExpanded: boolean
}

const Brand: React.FC<BrandProps> = ({ sidebarExpanded }) => {
  const { t } = useTranslation();

  return (
    <div className="app-brand demo">
      <Link
        className="app-brand-link"
        icon={
          <img
            src={sidebarExpanded ? Logo : '/assets/images/favicon-white.png'}
            className="app-brand-logo demo"
            alt={t('layout.pageTexts.private.sidebar.logoAltText')}
            data-app-light-img="assets/app-only/images/logo.png"
            data-app-dark-img="assets/app-only/images/logo.png"
          />
        }
      />
    </div>
  );
};

export default Brand;
